import * as React from 'react';
import isEmpty from 'lodash/isEmpty';

import Routes from 'routing/Routes';
import { Col, Row } from 'components/bootstrap';
import { Timestamp } from 'components/common';
import { Link } from 'components/common/router';
import type { EventEvidenceType } from 'security-app/hooks/api/investigationsAPI.types';
import LinkToReplaySearch from 'components/event-definitions/replay-search/LinkToReplaySearch';
import PriorityName from 'components/events/events/PriorityName';

type Props = {
  event: EventEvidenceType;
  hasEditPermissions: boolean;
  hasReadPermissions: boolean;
};

const EventDetails = ({ event, hasEditPermissions, hasReadPermissions }: Props) => (
  <Row>
    <Col md={6}>
      <dl>
        <dt>ID</dt>
        <dd>{event.id}</dd>
        <dt>Priority</dt>
        <dd>
          <PriorityName priority={event.priority} />
        </dd>
        <dt>Timestamp</dt>
        <dd>
          {' '}
          <Timestamp dateTime={event.timestamp} />
        </dd>
        <dt>Event Definition</dt>
        <dd>
          {hasEditPermissions ? (
            <Link to={Routes.ALERTS.DEFINITIONS.edit(event.event_definition_id)}>{event.event_definition_id}</Link>
          ) : (
            <div>{event.event_definition_id}</div>
          )}
          &emsp; ({event.event_definition_type})
        </dd>
        {event.replay_info && hasReadPermissions && (
          <>
            <dt>Actions</dt>
            <dd>
              <LinkToReplaySearch id={event.id} isEvent />
            </dd>
          </>
        )}
      </dl>
    </Col>
    <Col md={6}>
      <dl>
        {event.timerange_start && event.timerange_end && (
          <>
            <dt>Aggregation time range</dt>
            <dd>
              <Timestamp dateTime={event.timerange_start} />
              &ensp;&mdash;&ensp;
              <Timestamp dateTime={event.timerange_end} />
            </dd>
          </>
        )}
        <dt>Event Key</dt>
        <dd>{event.key || 'No Key set for this Event.'}</dd>
        <dt>Additional Fields</dt>
        {isEmpty(event.fields) ? (
          <dd>No additional Fields added to this Event.</dd>
        ) : (
          <ul>
            {Object.keys(event.fields).map((fieldName) => (
              <li key={fieldName}>
                <b>{fieldName}</b> {event.fields[fieldName]}
              </li>
            ))}
          </ul>
        )}
        <dt>Group-By Fields</dt>
        {isEmpty(event.group_by_fields) ? (
          <dd>No group-by fields on this Event.</dd>
        ) : (
          <ul>
            {Object.keys(event.group_by_fields).map((fieldName) => (
              <li key={fieldName}>
                <b>{fieldName}</b> {event.group_by_fields[fieldName]}
              </li>
            ))}
          </ul>
        )}
      </dl>
    </Col>
  </Row>
);

export default EventDetails;
